/* eslint-disable no-param-reassign */
import angular from 'angular';
import { cloneDeep, differenceBy, filter, get, orderBy, uniq } from 'lodash';
import '../components/operator';
import '../components/status';
import '../directives/wlvideo';
import '../services/area';
import '../services/display';
import '../services/displaytv';
import '../services/errors';
import '../services/globals';
import '../services/line';
import '../services/organization';
import '../services/redirect-to-new-version';
import '../services/theme';
import { localStorage } from '../utils';

const module = angular.module('whyline.controllers.display-tv', [
  'whyline.services.displaytv',
  'whyline.services.errors',
  'whyline.services.display',
  'whyline.services.globals',
  'whyline.services.line',
  'whyline.services.area',
  'whyline.services.redirect-to-new-version',
  'whyline.services.theme',
  'whyline.components.operator',
  'whyline.components.status',
  'whyline.directives.wlvideo',
  'whyline.services.organization',
]);

const DisplayTvController = (
  $scope,
  $rootScope,
  ErrorService,
  DisplayTvService,
  DisplayService,
  $interval,
  PlaceService,
  $state,
  ngAudio,
  $timeout,
  $log,
  Fullscreen,
  $window,
  RedirectToNewVersionService,
  $location,
  OrganizationService,
  ThemeService,
  blockUI,
) => {
  /* @ngInject */

  let sound = ngAudio.load('../../img/dingdong.mp3');

  const removeIfExists = (subscription, subscriptions) => {
    for (let index = subscriptions.length - 1; index >= 0; index--) {
      const item = subscriptions[index];
      const itemId = item._id || item.subscriptionId;
      const _id = subscription._id || subscription.subscriptionId;
      if (itemId && itemId === _id) {
        subscriptions.splice(index, 1);
      }
    }
  };

  const getNewData = () => {
    try {
      // Get subscriptions called
      DisplayTvService.GetDisplayTvData($state.params.displayId).then((displayTvData) => {
        $timeout(() => {
          const capacityControl = get($scope.currentDisplay, 'capacityControl', false);
          const diffProperty = capacityControl ? '_id' : 'subscriptionId';

          if (capacityControl) {
            displayTvData = orderBy(displayTvData, ['calledAt'], ['desc']);

            $scope.entryToCall = filter(displayTvData, ['status', 'waiting']);
            const completed = filter(displayTvData, ['status', 'completed']);
            const processing = filter(displayTvData, ['status', 'processing']);
            $scope.entryAlreadyCalled = orderBy(processing.concat(completed), ['_id'], ['desc']);
            $scope.entryAlreadyCalled = filter($scope.entryAlreadyCalled, ['type', 'virtual']);
          }

          $scope.toCall = differenceBy(displayTvData, $scope.data, diffProperty);
          try {
            const showNextCalls = getShowNextCalls($scope.currentDisplay);
            if (showNextCalls && $scope.toCall.length > 0) {
              updateNextCalls();
            }
            if ($scope.lastCalled) {
              removeIfExists($scope.lastCalled, $scope.toCall);
            }
          } catch (e) {
            console.error('getNewData - removeIfExists', e);
          }
        });
      });
    } catch (e) {
      console.error('getNewData', e);
    }
  };

  const getListToShow = (showNextCalls) => {
    let lastSubscriptionToDisplay = 10;
    if (showNextCalls) {
      lastSubscriptionToDisplay = 4;
    }
    return $scope.data.slice(0, lastSubscriptionToDisplay);
  }

  const callNext = () => {
    if ($scope.toCall.length) {
      const nextCall = $scope.toCall[0];
      if ($scope.lastCalled && nextCall.subscriptionId !== $scope.lastCalled.subscriptionId) {
        removeIfExists($scope.lastCalled, $scope.data);
        removeIfExists(nextCall, $scope.data);
        $scope.data.unshift($scope.lastCalled);
        const showNextCalls = getShowNextCalls($scope.currentDisplay);
        $scope.listToShow = getListToShow(showNextCalls);
      }

      $scope.doAnimation = new Date().getTime();

      $scope.lastCalled = $scope.toCall.shift();
      sound.play();
    }
  };

  const getShowNextCalls = (currentDisplay) => {
    $scope.topConfig = get(currentDisplay, 'topPosition', false);
    $scope.bottomConfig = get(currentDisplay, 'bottomPosition', false);
    const showNextCalls = $scope.topConfig && $scope.topConfig.enabled && $scope.topConfig.showSubscription === 'waiting' ||
    $scope.bottomConfig && $scope.bottomConfig.enabled && $scope.bottomConfig.showSubscription === 'waiting';
    return showNextCalls;
  }

  const updateNextCalls = () => {
    DisplayTvService.GetDisplayTvDataForNextCalls($state.params.displayId)
      .then(nextCalls => {
        $timeout(() => {
          const oldHiddenNextCalls = cloneDeep($scope.nextCalls);
          const oldShownNextCalls = oldHiddenNextCalls.splice(0, 10);
          const nextCallsFiltered = differenceBy(nextCalls, oldShownNextCalls, 'subscriptionId');
          $scope.nextCalls = oldShownNextCalls.concat(nextCallsFiltered);
        });
      });
  };

  let wsDisplay;

  $scope.place = {};
  $scope.organization = {};
  $scope.currentVideo = null;
  $scope.animationClass = '';
  $scope.isMacro = false;
  $scope.themeClass = '';

  $scope.doAnimation = undefined;

  $scope.fontSize = $state.params.fontSize;
  $scope.showOnly = $state.params.showOnly;
  $scope.data = [];
  $scope.toCall = [];
  $scope.listToShow = [];
  $scope.nextCalls = [];
  $scope.entryAlreadyCalled = [];
  $scope.entryToCall = [];
  $scope.identify = false;
  $scope.socketIsDown = true;
  $scope.lastCalled = null;
  $scope.calling = null;
  let counter = 0;

  const wholeApp = blockUI.instances.get('wholeApp');

  wholeApp.start('...');

  const placePromise = PlaceService.GetOneAsPromiseFromServer($state.params.placeId);
  const orgPromise = OrganizationService.GetCurrentAsPromise();
  const displayPromise = DisplayService.GetOneAsPromise($state.params.displayId);
  const displayDataPromise = DisplayTvService.GetDisplayTvData($state.params.displayId);
  const displayDataNextCallsPromise = DisplayTvService.GetDisplayTvDataForNextCalls($state.params.displayId);
  const promises = [placePromise, orgPromise, displayPromise, displayDataPromise, displayDataNextCallsPromise];

  // Do this when display load first time
  Promise.all(promises)
    .then(([place, organization, currentDisplay, displayTvData, nextCalls]) => {
      $timeout(() => {
        $scope.place = place;

        if ($scope.place.revertMigration) {
          RedirectToNewVersionService.Redirect(
            'display',
            place._id,
            localStorage.get('user')._id,
            $state.params.displayId,
          );
        }

        $scope.placeVideos = cloneDeep($scope.place.videos);
        $scope.videos = [...$scope.place.videos];

        $scope.organization = organization;
        $scope.themeClass = ThemeService.getThemeClass($scope.organization.slug);
        $scope.animationClass = ThemeService.getDisplayAnimationClass($scope.organization.slug);
        $scope.showLastCallLabel = $scope.themeClass === 'atm-misiones';
        $scope.showNextCallLabel = false;
        $scope.showWhylineLogo = true;

        //hidden whyline logo
        const tenantsWhylineLogoHidden = ['santander-mx', 'sim', 'auna'];
        if (tenantsWhylineLogoHidden.includes($scope.themeClass)) {
          $scope.showWhylineLogo = false;
        }

        //change sound
        const tenantsWithOwnSound = ['santander-mx'];
        if (tenantsWithOwnSound.includes($scope.themeClass)) {
          sound = ngAudio.load(`../../img/display-tv/${$scope.themeClass}-dingdong.mp3`);
        }

        // Putting the current display available on scope
        $scope.currentDisplay = currentDisplay;

        // Get subscriptions called
        $scope.data = displayTvData;

        if (!currentDisplay.capacityControl) {
          $scope.lastCalled = $scope.data.shift();
          const showNextCalls = getShowNextCalls(currentDisplay);
          if (showNextCalls) {
            $scope.nextCalls = nextCalls;
          }
          $scope.listToShow = getListToShow(showNextCalls);
        } else {
          $scope.showNextCallLabel = true;
          $scope.showLastCallLabel = false;
          const ordered = uniq(orderBy(displayTvData, ['_id'], ['desc']), '_id');

          const waiting = filter(ordered, ['status', 'waiting']);
          const processing = filter(ordered, ['status', 'processing']);
          const completed = filter(ordered, ['status', 'completed']);
          $scope.entryAlreadyCalled = orderBy(processing.concat(completed), ['_id'], ['desc']);
          $scope.entryAlreadyCalled = filter($scope.entryAlreadyCalled, ['type', 'virtual']);
          $scope.entryToCall = orderBy(waiting, ['_id'], ['asc']);
        }

        wholeApp.stop();
      });
    })
    .catch(ErrorService.handler);

  $rootScope.$on('socket:display-connected', (event, socket) => {
    wsDisplay = socket;

    $scope.socketIsDown = false;

    socket.emit('display:opened', $state.params.displayId);
  });

  $rootScope.$on('display:recall-subscription', (event, data) => {
    removeIfExists(data, $scope.toCall);

    $scope.toCall.unshift(data);
  });

  $rootScope.$on('display:call-subscription', (event, data) => {
    removeIfExists(data, $scope.toCall);
    if ($scope.currentDisplay.showNextCalls) {
      removeIfExists(data, $scope.nextCalls);
    }
    $scope.toCall.push(data);
  });

  $rootScope.$on('display:update-next-calls', (event, data) => {
    if (!data) {
      updateNextCalls();
    } else {
      removeIfExists(data, $scope.nextCalls);
    }
  });

  $rootScope.$on('display:ping', () => {
    try {
      if (wsDisplay) {
        wsDisplay.emit('display:pong', $state.params.displayId);
      }
    } catch (e) {
      console.error('display:ping', e);
    }
  });

  $rootScope.$on('display:entry:created', (event, data) => {
    $scope.entryToCall.push(data.entry);
    $scope.entryToCall = orderBy(uniq($scope.entryToCall, '_id'), ['_id'], ['asc']);
  });

  $rootScope.$on('display:entry:updated', (event, data) => {
    if (data.status === 'canceled') {
      removeIfExists(data, $scope.entryToCall);
    } else if (data.status === 'processing') {
      $scope.calling = data;
      $scope.doAnimation = new Date().getTime();
      sound.play();
      $timeout(() => {
        $scope.calling = null;
        removeIfExists(data, $scope.entryToCall);
        $scope.entryAlreadyCalled.push(data);
      }, 2000);
    }
  });

  $rootScope.$on('display:identify', () => {
    $scope.identify = true;
    $timeout(() => ($scope.identify = false), 5000);
  });

  $rootScope.$on('display:refresh', () => {
    $window.location.reload();
  });

  $rootScope.$on('display:minmax', () => {
    if (Fullscreen.isEnabled()) {
      Fullscreen.cancel();
    } else {
      Fullscreen.all();
    }
  });

  $rootScope.$on('display:reconnected', () => {
    $scope.socketIsDown = false;
  });

  $rootScope.$on('display:disconnected', () => {
    $scope.socketIsDown = true;
  });

  $rootScope.$emit('connect-display-socket');

  $scope.pressForFullScreen = () => {
    if (counter < 3) {
      counter += 1;
    }
    if (counter === 3) {
      counter = 0;
      if (Fullscreen.isEnabled()) {
        Fullscreen.cancel();
      } else {
        Fullscreen.all();
      }
    }
  };

  $scope.stopCurrentDisplayRefresh = $interval(() => {
    PlaceService.GetOneAsPromiseFromServer($scope.place._id).then((res) => {
      $timeout(() => {
        const videosFromServer = get(res, 'videos', []);
        const brokenVideos = differenceBy($scope.placeVideos, $scope.videos, 'src');
        const newVideos = differenceBy(videosFromServer, brokenVideos, 'src');
        $scope.videos = newVideos;
        $scope.placeVideos = videosFromServer;
      });
    });
  }, 2 * 60 * 1000); // 2 minutes

  // Get data if socket is down
  const stopGettingNewData = $interval(() => {
    if ($scope.socketIsDown) {
      getNewData();
    }
  }, 5000); // 5 secs

  // Refresh subscriptions every [given time]
  const checkIfHaveToCall = $interval(() => {
    callNext();
  }, 4000); // 4 secs

  $scope.$on('$destroy', () => {
    if (angular.isDefined(stopGettingNewData)) {
      $interval.cancel(stopGettingNewData);
    }
    if (angular.isDefined(checkIfHaveToCall)) {
      $interval.cancel(checkIfHaveToCall);
    }
    if (angular.isDefined(stopCurrentDisplayRefresh)) {
      $interval.cancel(stopCurrentDisplayRefresh);
    }
  });
};

module.exports = module.controller('DisplayTvController', DisplayTvController);
